import { UsersRound, UserRound } from 'lucide-react';
import type { ReferenceData } from './types';

export function TaskScopeControls({ value, onChange, users, currentUserId }: {
  value: string;
  onChange: (value: string) => void;
  users: ReferenceData['users'];
  currentUserId: number;
}) {
  return <div className="task-scope-controls" aria-label="Task assignee filters">
    <button type="button" className={`task-scope-mine ${value === 'mine' ? 'is-active' : ''}`} aria-pressed={value === 'mine'} onClick={() => onChange('mine')}><UserRound size={16} />My tasks</button>
    <label className="task-scope-employee"><span>Employee</span><select aria-label="Select employee for tasks" value={['mine', 'all'].includes(value) ? '' : value} onChange={(event) => onChange(event.target.value || 'mine')}>
      <option value="">Choose employee</option>
      {users.filter((user) => user.role !== 'client' && user.id !== currentUserId).map((user) => <option key={user.id} value={user.id}>{user.name}</option>)}
    </select></label>
    <button type="button" className="task-scope-all" role="switch" aria-label="Show everyone's tasks" aria-checked={value === 'all'} onClick={() => onChange(value === 'all' ? 'mine' : 'all')}><UsersRound size={16} /><span>All</span><i aria-hidden="true" /></button>
  </div>;
}

export function taskScopeAssignee(value: string, userId: number) {
  return value === 'all' ? '' : value === 'mine' ? String(userId) : value;
}
